import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import SingleSelect from '../../common/Forms/SingleSelect';

const SchoolSingleSelect = ({ options, selectedValue, name, creatable = false }) => {
  const [selectedOption, setSelectedOption] = useState(selectedValue);

  const handleChange = (option) => {
    setSelectedOption(option);

    if (name === 'template[school_id]') {
      const schoolIdInput = document.getElementById('award_school_id');
      if (schoolIdInput) {
        schoolIdInput.value = option ? option.value : '';
      }
    } 
    
    if (name === 'template[category]') {
      // throw event for listener
      const event = new CustomEvent('categoryChanged', { detail: { category: option ? option.value : '' } });
      document.dispatchEvent(event);  
    }
  };

  return (
    <Fragment>
      <input name={name}
             value={selectedOption && selectedOption.value}
             hidden/>
      <SingleSelect
        handleChange={handleChange}
        options={options}
        selectedValue={selectedValue}
        creatable={creatable}
      />
    </Fragment>
  );
};

SchoolSingleSelect.propTypes = {
  options: PropTypes.array,
  selectedValue: PropTypes.object
};

SchoolSingleSelect.defaultProps = {
  options: [{}],
  selectedValue: {}
};

export default SchoolSingleSelect;
